import { render, staticRenderFns } from "./FeedbackType.vue?vue&type=template&id=b97dc8f8&scoped=true&"
import script from "./FeedbackType.vue?vue&type=script&lang=js&"
export * from "./FeedbackType.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackType.vue?vue&type=style&index=0&id=b97dc8f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97dc8f8",
  null
  
)

export default component.exports